export default "__VITE_ASSET__9838a266__"